export function getPhoenixConfigAssetsBaseUrl(phoenixConfigBucket: string, region = 'eu-west-1'): string {
  return `https://${phoenixConfigBucket}.s3.${region}.amazonaws.com`;
}

export function getPhoenixConfigAssetUrl(imageKey: string, phoenixConfigAssetsBaseUrl: string): string {
  return new URL(imageKey, `${phoenixConfigAssetsBaseUrl}/`).toString();
}
